import {AxiosError} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';
import {useAccessToken} from '@eksab/hooks/useAccessToken';

import {useGuestStore} from './useGuestStore';
import type {SubmitAnswerError, SubmitAnswerParams, SubmitAnswerResponse} from '../types';

export const useSubmitAnswerMutation = (
  attemptID: string,
  options?: UseMutationOptions<SubmitAnswerResponse, AxiosError<SubmitAnswerError>, SubmitAnswerParams>,
) => {
  const accessTokenQuery = useAccessToken();

  const isLoggedIn = accessTokenQuery.isSuccess;

  return useMutation<SubmitAnswerResponse, AxiosError<SubmitAnswerError>, SubmitAnswerParams>(
    ({questionID, answers}) =>
      api
        .post<{data: SubmitAnswerResponse}>(
          `v1/attempts/${attemptID}/questions/${questionID}/submit-answer`,
          {
            answers: answers.map((answer) => answer.id),
          },
          {
            headers: {
              Authorization: `Bearer ${isLoggedIn ? accessTokenQuery.data : useGuestStore.getState().token}`,
            },
          },
        )
        .then((res) => res.data.data),
    options,
  );
};
